export const SET_COMPANY_ID = 'SET_COMPANY_ID';
export const REMOVE_COMPANY_ID = 'REMOVE_COMPANY_ID';
